import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setOnUnauthorized } from "../services/api";
import { clearTeacherToken, setTeacherToken } from "../services/authStorage";
import { normalizeTeacher } from "../services/apiUtils";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const logout = () => {
        clearTeacherToken();
        setUser(null);
    };

    useEffect(() => {
        setOnUnauthorized(() => logout());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/teacher");
                setUser(normalizeTeacher(data) || null);
            } catch (_) {
                clearTeacherToken();
                setUser(null);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const login = (userData, token) => {
        if (token) setTeacherToken(token);
        setUser(normalizeTeacher(userData));
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
